import { Column, ColumnStore } from '@bryntum/grid';

export class RmsObjectsGridColumnImage extends Column {
    // Define the type for this column, used in your columns config to add this column
    static get type() {
        return 'imageColumn';
    }

    // Override default values
    static get defaults() {
        return {
            field  : 'imageThumb',
            align  : 'center',
            cellCls: 'custom-cell-image',
            editor : false,
            htmlEncode: false,
        };
    }

    renderer({ record, value }) {
        if (value) {
            //let tpl = '<img src="' + value + '"/>';
            let tpl = '<span style="width: 100%; height: 100%; background-position: center center; background-repeat: no-repeat; background-size: contain; background-image: url(\'' + value + '\')"></span>';
            return tpl;
        } else {
            // TODO: Hier sind statische IDs hinterlegt - sollte ggf. in der Felddefinition konfigurierbar sein
            if(record.data.field_set_definition_id == 1){
                return '<i class="fad fa-bicycle fa-2x"></i>';
            }else if(record.data.field_set_definition_id == 2){
                return '<i class="fad fa-phone-laptop fa-2x"></i>';
            }else if(record.data.field_set_definition_id == 3){
                return '<i class="fad fa-car-side fa-2x"></i>';
            }else{
                return '<i class="fad fa-box fa-2x"></i>';
            }
        }
    }
};

ColumnStore.registerColumnType(RmsObjectsGridColumnImage);
